import { Box, Heading, Text, VStack, SimpleGrid, Icon, HStack, Button } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faObjectGroup, faChartPie, faServer } from '@fortawesome/free-solid-svg-icons';
import MarketingLayout from '../components/marketing/MarketingLayout';

const values = [
  { icon: faLock, title: 'Data ownership', text: 'Your visitor data is yours. We never sell it, never share it with advertisers, and never use it to train anything.' },
  { icon: faObjectGroup, title: 'One platform', text: 'Analytics and ad serving belong together. Splitting them across tools is why your numbers never match.' },
  { icon: faChartPie, title: 'Honest metrics', text: 'No sampling, no dark patterns, no inflated vanity numbers — just the traffic and revenue figures you can act on.' },
  { icon: faServer, title: 'Your way', text: 'Run it in our cloud for zero setup, or self-host for full control. Same product, same data, your choice.' },
];

export const AboutPage = () => (
  <MarketingLayout title="About StatFalcon" subtitle="Analytics and ad serving that respect your data and your budget.">
    <VStack align="stretch" spacing={6}>
      <Text color="gray.700" fontSize="lg" lineHeight="1.8">
        StatFalcon exists because measuring your audience and monetizing it shouldn't mean handing your data to Big
        Tech or stitching together half a dozen tools that never agree with each other. We built a single platform
        that does both — privacy-first web analytics and a full ad server — so you get one source of truth for your
        traffic and your revenue.
      </Text>
      <Text color="gray.700" fontSize="lg" lineHeight="1.8">
        Whether you run it in our cloud or self-host it on your own servers, the data belongs to you. No third-party
        cookies, no consent-banner theater, no per-impression surprises on your invoice.
      </Text>

      <Heading size="lg" color="gray.900" mt={8}>What we believe</Heading>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5}>
        {values.map((v) => (
          <HStack key={v.title} align="start" spacing={4} p={6} bg="gray.50" borderRadius="2xl" border="1px solid" borderColor="gray.200">
            <Box w={11} h={11} bgGradient="linear(135deg, brand.500, accent.500)" borderRadius="xl" display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
              <Icon as={FontAwesomeIcon} icon={v.icon} color="white" />
            </Box>
            <Box>
              <Heading size="sm" color="gray.900" mb={1}>{v.title}</Heading>
              <Text color="gray.600" lineHeight="1.7">{v.text}</Text>
            </Box>
          </HStack>
        ))}
      </SimpleGrid>

      <Box mt={8} p={8} bgGradient="linear(135deg, brand.600, brand.800)" color="white" borderRadius="2xl" textAlign="center">
        <Heading size="md" mb={3}>Have a question or want a demo?</Heading>
        <Text opacity={0.9} mb={6}>We'd love to hear how you're tracking and monetizing your sites.</Text>
        <Button as={RouterLink} to="/contact" bg="white" color="brand.600" borderRadius="xl" _hover={{ bg: 'gray.100' }}>Get in touch</Button>
      </Box>
    </VStack>
  </MarketingLayout>
);

export default AboutPage;
